<template>
  <div>
    <v-expansion-panels accordion v-model="panelPlan">
      <v-expansion-panel>
        <v-expansion-panel-header>{{ m.config.form.title }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <a-form-modelCols
            v-if="!!m"
            v-model="data"
            class="pb-3"
            :model="getFormModel(m.config.form.fieldsForm.split(','), model_local)"
            :values="data"
            :errors="errors"
            :config="{ dense: true, readonly, hideDetails: 'auto' }"
            @validate="_validate($event)"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <span v-if="error" style="color: red">{{ error }}</span>
  </div>
</template>

<script>
import { getForm, getAccess, libChecks, genModel, validate } from "@/components/mixings";
export default {
  mixins: [libChecks, getAccess, getForm, genModel, validate],
  props: {
    value: { type: Object, default: () => {} },
    model: Object,
    error: {
      type: String,
      default: "",
    },
    config: {
      type: Object,
      default: () => {
        return { dense: true, hideDetails: "auto" };
      },
    },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      panelPlan: 0,
      model_local: [],
      m: null,
    };
  },
  computed: {
    m_local() {
      let m;
      if (typeof this.model.model === "string") m = this.getObjectPath(this.$store.getters["config/get"].models, this.model.model);
      if (typeof this.model.model === "object") m = Object.assign({}, this.model.model);
      return m;
    },
    data1: {
      set(v) {
        this.$emit("input", v);
      },
      get() {
        let res = [];
        if (this.value) res = this.value;
        if (!Object.isObject(res)) res = {};
        return res;
      },
    },
  },
  created() {
    this.reset();
    this.fillForm();
    this.fetchData(this.value);
  },
  watch: {
    value: {
      handler(v) {
        this.reset();
        this.fetchData(v);
      },
      deep: true,
    },
  },
  methods: {
    async _validate(e) {
      let _noError = false;
      if (await this.validateAll(this.data, true)) {
        _noError = true;
      } else {
      }
      let data = Object.assign({}, this.data, { _noError });
      //this.validateData(data, this.model_local, true);

      this.$emit("input", data);
    },
    reset() {
      this.m = this.getObjectPath(this.$store.getters["config/get"].models, this.model.model);
    },
    fillForm() {
      if (!this.m) return;
      this.model_local = this.m.form;
      this.fillFormFromModel(this.model_local);
    },
    fetchData(data) {
      for (const name in data) {
        if (name == "data") {
        }
        if (name == "data" && this.data?.data && data[name]) {
          for (const nameData in data.data) {
            this.$set(this.data.data, nameData, data.data[nameData]);
          }
        } else if (name == "data" && typeof this.data.data == "object") {
        } else {
          this.$set(this.data, name, data[name]);
        }
      }
    },
  },
};
</script>

<style lang="scss"></style>
